/* eslint-disable react/prop-types */
import React, {Component} from 'react';
import {Platform, TouchableOpacity, View} from 'react-native';
import {CLOSE_TICKER_LOGIN_FLAG, CUST_ID, CLOSE_TICKER_FLAG, getPrefData, storePrefData, RESCOUNTRYID} from '../../src/storage/preferenceStorage';
import {COUNTRY_USA} from '../utils/countryCode';
import {AppConsumer} from '../AppContext';
import {getLoginTickerText} from '../network/request/commons/getTickerLoginContent';
import {getTickerText} from '../network/request/commons/getTickerContent';
import CustomText from './customText';

const style = {
  marqueTextCss: {
    // padding: 15,
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 15,
    paddingRight: 25,
    backgroundColor: '#f5d2d6',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // alignContent: 'center',
    alignItems: 'center'
  },
  marqueTextStyle: {
    fontSize: 12,
    color: '#4a4a4a',
    fontWeight: 'bold'
  },
  marqueCloseBtnCss: {
    fontSize: 20,
    color: '#4a4a4a',
    fontWeight: 'bold'
  }
};

const isNative = Platform.OS !== 'web';
let closeTickerFlagLogin;
let closeTickerFlag;

class TickerComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    const {tickerValues, setContext} = this.context;
    const custId = await getPrefData(CUST_ID);
    const countryId = await getPrefData(RESCOUNTRYID);
    closeTickerFlagLogin = await getPrefData(CLOSE_TICKER_LOGIN_FLAG);
    closeTickerFlag = await getPrefData(CLOSE_TICKER_FLAG);

    if (custId && custId !== undefined) {
      if (closeTickerFlagLogin === undefined || closeTickerFlagLogin === 'undefined') {
        setContext({tickerValues: {...tickerValues, hide: false}});
      }
      let data;
      if (countryId === COUNTRY_USA) {
        data = {};
      } else {
        data = {
          countryId
        };
      }

      switch (isNative && !tickerValues.api_called && !tickerValues.hide) {
        case true:
          this.props.makeAPICall(
            getLoginTickerText(data),
            response => {
              if (response.status === 'success') {
                setContext({
                  tickerValues: {
                    ...tickerValues,
                    api_called: true,
                    text: response.value
                  }
                });
                storePrefData(CLOSE_TICKER_LOGIN_FLAG, false);
              }
            },
            err => {},
            () => {}
          );
          break;
        default:
          break;
      }
    } else {
      if (closeTickerFlag === undefined || closeTickerFlag === 'undefined') {
        setContext({tickerValues: {...tickerValues, hide: false}});
      }
      switch (isNative && !tickerValues.api_called && !tickerValues.hide) {
        case true:
          this.props.makeAPICall(
            getTickerText(),
            response => {
              if (response.status === 'success') {
                setContext({
                  tickerValues: {
                    ...tickerValues,
                    api_called: false,
                    text: response.value
                  }
                });
                storePrefData(CLOSE_TICKER_LOGIN_FLAG, false);
              }
            },
            err => {},
            () => {}
          );
          break;
        default:
          break;
      }
    }
  }

  render() {
    const {tickerValues, setContext} = this.context;
    // let mText = tickerValues.text ? true : false;
    switch (isNative && !tickerValues.hide) {
      case true:
        return (
          <View>
            {tickerValues.text ? (
              <View style={style.marqueTextCss}>
                <CustomText style={style.marqueTextStyle}>{tickerValues.text}</CustomText>
                <View>
                  <TouchableOpacity
                    style={{
                      alignSelf: 'flex-start',
                      display: 'flex',
                      flexDirection: 'row'
                    }}
                    onPress={() => {
                      setContext({tickerValues: {...tickerValues, hide: true}});
                      storePrefData(CLOSE_TICKER_LOGIN_FLAG, true);
                      storePrefData(CLOSE_TICKER_FLAG, true);
                    }}>
                    <CustomText style={style.marqueCloseBtnCss}>×</CustomText>
                  </TouchableOpacity>
                </View>
              </View>
            ) : null}
          </View>
        );

      default:
        return null;
    }
  }
}

TickerComponent.contextType = AppConsumer;

export default TickerComponent;
